import dayjs, { Dayjs } from 'dayjs';

// Shared-basket timestamps (`expires_at`, `created_at`, `disabled_at`) come
// back naive - no "Z", no offset - and are UTC. Passing one straight to
// dayjs() reads it as LOCAL time, which shows the creator, the recipient and
// the links list three different dates for the same link. Every shared-basket
// date must go through here.
const hasTimezone = (value: string) =>
  /(?:Z|[+-]\d{2}:?\d{2})$/i.test(value.trim());

// The portal's date format
export const SHARED_BASKET_DATE_FORMAT = 'YYYY MMM DD';

export const parseSharedBasketDate = (value: string): Dayjs =>
  dayjs(hasTimezone(value) ? value : `${value}Z`);

// "2026 Sep 15" - the duration always resolves to a visible date.
export const formatSharedBasketDate = (value: string): string =>
  parseSharedBasketDate(value).format(SHARED_BASKET_DATE_FORMAT);
